import React, { useEffect } from 'react';
import { Button, Tabs } from 'antd';
import type { TabsProps } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import s from './s.module.less';
import {Benefits, HowItWork, Pricing, FAQ, ESection } from './Tabs';
import Frame from './imgs/Frame.png';
import { IPaymentInfo } from 'types/common';
import ZoomIcon from '../imgs/zoom.png';
import NewIcon from './imgs/new.png';
import { PATH } from 'constants/path';

type Props = {
    onGetStarted?: () => void;
    onClose: () => void;
};

const PrescriptionsLandingPage = (props: Props) => {
    const [activeId, setActiveId] = React.useState(ESection.BENEFITS);

    useEffect(() => {

    }, []);

    const guideItems: TabsProps['items'] = [
        {
            key: ESection.BENEFITS,
            label: <div>Benefits</div>,
            children: <div />,
        },
        {
            key: ESection.HOW_IT_WORKS,
            label: <div>How it works</div>,
            children: <div />,
        },
        {
            key: ESection.PRICING,
            label: <div>Pricing & fees</div>,
            children: <div />,
        },
        {
            key: ESection.FAQ,
            label: <div>FAQs</div>,
            children: <div />,
        },
    ];

    const handleChange = (activeKey: ESection) => {
        setActiveId(activeKey as ESection);
        const element = document.getElementById(activeKey as ESection);
        const wrapElement = document.getElementById('contentWrap');
        const toScrollTop = (element as HTMLBaseElement).offsetTop - 150;
        
        if (toScrollTop > 0 &&  wrapElement?.parentElement) {
            wrapElement.parentElement.scrollTo({
                top: toScrollTop,
                behavior: 'smooth',
            });
        }
    };

    const location = useLocation();
    const navigate = useNavigate();

    const handleGetStarted = () => {
        const isInCalendarSettingPage = location.pathname.includes(PATH.CALENDAR_SETTING);
        props.onClose();
        if (!isInCalendarSettingPage) {
            navigate(`${PATH.DASHBOARD}/${PATH.CALENDAR_SETTING}?tab=2`);
        }
        props.onGetStarted?.();
    }

    React.useEffect(() => {
        const wrap = document.getElementById('contentWrap');
        const howItWork = document.getElementById(ESection.HOW_IT_WORKS);
        const pricing = document.getElementById(ESection.PRICING);
        const faq = document.getElementById(ESection.FAQ);
        const handle = () => {
            const top = wrap?.parentElement?.scrollTop;
            if (!top) return;
            const slug = 500;
            if (faq && top && (top + slug) > faq?.offsetTop) {
                setActiveId(ESection.FAQ);
            } else if (howItWork && top && (top + slug) > howItWork?.offsetTop) {
                setActiveId(ESection.HOW_IT_WORKS);
            } else if (pricing && top && (top + slug) > pricing?.offsetTop) {
                setActiveId(ESection.PRICING);
            }  else {
                setActiveId(ESection.BENEFITS);
            }
        };
        wrap?.addEventListener('scroll', handle);
        return () => {
            wrap?.removeEventListener('scroll', handle);
        };
    }, []);

    return (
        <div
            className={`${s.wrap} ${s.wrapModal}`}
            id="contentWrap"
        >
            <div className={s.header}>
                <div className={s.left}>
                    <div className={s.title}>
                        <img className={s.newIcon} src={NewIcon} />Built-in telehealth software,<br />
                        free on Klarity (In partnership with <img className={s.modalTitleIcon} src={ZoomIcon} />)
                    </div>
                    <div className={s.des}>
                        Klarity Meet is a <strong>HIPAA-secure video visit experience that lives directly inside Klarity</strong> – in your schedule, in your patient portal, and next to your notes.
                    </div>
                    <div className={s.startBtn}>
                        <Button
                            type="primary"
                            shape='round'
                            onClick={handleGetStarted}
                        >Get started now
                        </Button>
                    </div>

                </div>
                <div className={s.right}>
                    <img src={Frame} />
                </div>
            </div>
            <div className={s.tabs}>
                <Tabs
                    activeKey={activeId}
                    items={guideItems}
                    onChange={(activeKey) => handleChange(activeKey as ESection)}
                />
            </div>
            <div className={s.content} id={ESection.BENEFITS}>
                <Benefits />
            </div>
            <div className={s.content} id={ESection.HOW_IT_WORKS}>
                <HowItWork />
            </div>
            <div className={s.content} id={ESection.PRICING}>
                <Pricing onGetStarted={handleGetStarted} />
            </div>
            <div className={s.content} id={ESection.FAQ}>
                <FAQ />
            </div>
        </div>
    );
};

export default PrescriptionsLandingPage;
